// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__UELSH","mascot":"VerifyEmail_mascot__6pyHr","message":"VerifyEmail_message__JOLdk","loginLink":"VerifyEmail_loginLink__37ta7"};